import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaHome,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    contactNo: "",
    email: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("✅ तुमचा संदेश यशस्वीरित्या पाठवला गेला आहे!");
    setFormData({
      fullName: "",
      contactNo: "",
      email: "",
      address: "",
      message: "",
    });
  };

  // ⭐ Internal CSS for Contact Section
  const sectionStyles = {
    container: {
      maxWidth: "1100px",
      margin: "50px auto",
      padding: "10px",
    },
    title: {
      textAlign: "center",
      marginBottom: "30px",
      color: "red",
      fontSize: "32px",
      fontWeight: "700",
    },
    row: {
      display: "flex",
      justifyContent: "center",
      gap: "25px",
      flexWrap: "wrap",
    },
    card: {
      padding: "25px",
      borderRadius: "12px",
      textAlign: "center",
      width: "300px",
      boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
      color: "white",
      fontSize: "18px",
      fontWeight: "500",
    },
  };

  const ContactSection = () => (
    <div style={sectionStyles.container}>
      <h2 style={sectionStyles.title}>संपर्क माहिती</h2>

      <div style={sectionStyles.row}>
        
        {/* Address */}
        <div style={{ ...sectionStyles.card, backgroundColor: "#0d6efd" }}>
          <h3>📍 पत्ता</h3>
          <p style={{ marginTop: "10px" }}>
            ग्रामपंचायत पिपरा<br />
            पं.स.  उमरेड, जि. नागपूर<br />
            महाराष्ट्र 441108
          </p>
        </div>

        {/* Phone */}
        <div style={{ ...sectionStyles.card, backgroundColor: "#198754" }}>
          <h3>📞 फोन</h3>
          <p style={{ marginTop: "10px" }}>
            8669393515
          </p>
          <p>
            कार्यालयीन वेळ:<br />
            सकाळी ९:०० ते दुपारी ५:००
          </p>
        </div>

        {/* Email */}
        <div style={{ ...sectionStyles.card, backgroundColor: "#ffc107", color: "black" }}>
          <h3>✉ ई-मेल</h3>
          <p style={{ marginTop: "10px" }}>gppipra@gmail.com </p>
        </div>
      </div>
    </div>
  );

  // Main form styles ( तुमचे आधीच दिलेले )
  const styles = {
    main: {
      fontFamily: "Poppins, sans-serif",
      background: "linear-gradient(135deg, #e8f5e9, #ffffff)",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    container: {
      maxWidth: "800px",
      margin: "30px auto",
      backgroundColor: "#fff",
      padding: "40px",
      borderRadius: "20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      borderTop: "6px solid #16a34a",
    },
    heading: {
      fontSize: "30px",
      color: "#14532d",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "10px",
    },
    subheading: {
      textAlign: "center",
      color: "#666",
      marginBottom: "25px",
    },
    label: { display: "block", marginBottom: "5px", fontWeight: "600" },
    input: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #bbf7d0",
      outline: "none",
      marginBottom: "18px",
      fontSize: "15px",
      transition: "0.3s",
    },
    textarea: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #bbf7d0",
      outline: "none",
      marginBottom: "18px",
      fontSize: "15px",
    },
    button: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#16a34a",
      border: "none",
      borderRadius: "8px",
      color: "white",
      fontWeight: "700",
      fontSize: "16px",
      cursor: "pointer",
    },
    footer: {
      backgroundColor: "#14532d",
      color: "white",
      textAlign: "center",
      padding: "25px 15px",
      marginTop: "40px",
    },
    footerLinks: {
      display: "flex",
      justifyContent: "center",
      gap: "25px",
      flexWrap: "wrap",
      marginBottom: "10px",
    },
    socialIcons: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      marginBottom: "10px",
    },
  };

  return (
    <div style={styles.main}>

      {/* ⭐ Contact Information Section with Internal CSS */}
      <ContactSection />

      <div style={styles.container}>
        <h1 style={styles.heading}>📞 संपर्क करा (Contact Us)</h1>
        <p style={styles.subheading}>
          तुमचे प्रश्न, सूचना आणि अभिप्राय आमच्यासाठी मौल्यवान आहेत.
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <label style={styles.label}>पूर्ण नाव:</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="आपले पूर्ण नाव लिहा"
            required
            style={styles.input}
          />

          <label style={styles.label}>संपर्क क्रमांक:</label>
          <input
            type="tel"
            name="contactNo"
            value={formData.contactNo}
            onChange={handleChange}
            placeholder="मोबाईल नंबर लिहा"
            required
            style={styles.input}
          />

          <label style={styles.label}>ईमेल:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="example@gmail.com"
            required
            style={styles.input}
          />

          <label style={styles.label}>पत्ता:</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="आपला पत्ता लिहा"
            rows="2"
            style={styles.textarea}
          ></textarea>

          <label style={styles.label}>संदेश:</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="आपला संदेश लिहा"
            rows="3"
            style={styles.textarea}
          ></textarea>

          <button type="submit" style={styles.button}>
            ✉️ संदेश पाठवा
          </button>
        </form>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerLinks}>
          <Link to="/" style={{ color: "white", textDecoration: "none" }}>
            Home
          </Link>
          <Link to="/aboutus" style={{ color: "white", textDecoration: "none" }}>
            About Us
          </Link>
          <Link to="/gallery" style={{ color: "white", textDecoration: "none" }}>
            Gallery
          </Link>
          <Link
            to="/gramsevakpage"
            style={{ color: "white", textDecoration: "none" }}
          >
            ग्रामसेवक
          </Link>
          <Link
            to="/vikas"
            style={{ color: "white", textDecoration: "none" }}
          >
            विकास कामे
          </Link>
        </div>

        <div style={styles.socialIcons}>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <FaFacebook size={28} color="white" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <FaInstagram size={28} color="white" />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <FaTwitter size={28} color="white" />
          </a>
        </div>

        <p style={{ fontSize: "14px", marginTop: "10px" }}>
          <FaHome /> ग्रामपंचायत पिपरा, पंचायत समिती:उमरेड  जिल्हा नागपूर
          <br />
          <FaPhoneAlt /> संपर्क: 8669393515 | <FaEnvelope /> grampanchayat@gov.in
          <br />
          © 2025 ग्रामपंचायत पिपरा | सर्व हक्क राखीव.
        </p>
      </footer>
    </div>
  );
};

export default Contact;
